import { PagosEnvironment } from 'src/environments/pagos-environments';
import {
  EnvironmentDev,
  TenantName,
} from '@segurosvoluntarios_vel/commons-services';

export const environment: PagosEnvironment = {
  ...EnvironmentDev.environment,
  prismicApi: 'https://suraenlinea-v2.cdn.prismic.io/graphql',
  pagosApi: 'https://suraenlineaservicios.labsura.com/ms-pagos/pago',
  maestrosApi: 'https://suraenlineaservicios.dllosura.com/maestros',
  tenants: [
    {
      tenant: TenantName.SURA,
      hostname: 'http://localhost:4200',
      pixelResponsys: {
        url: '',
        width: '',
        height: '',
      },
      googleTagManager: {
        GTM: 'GTM-5R4TXN',
        globalSite: 'UA-27527568-1',
        UA: 'UA-27527568-1',
        optimizeId: 'GTM-PSFM4S5',
      },
      facebookPixel: {
        code: '380531805706245',
        facebookEvents: ['PageView'],
      },
      userVoice: 'fstYbP5lDoofPPZa8JFig',
      url: '/',
      codigoCanal: '7771',
      codigoAsesor: '4999',
    },
    {
      tenant: TenantName.BANCOLOMBIA,
      hostname: 'local.suraenlinea.com:9000',
      pixelResponsys: {
        url: '',
        width: '',
        height: '',
      },
      googleTagManager: {
        GTM: 'GTM-PHSGXJ',
        UA: '',
        optimizeId: '',
      },
      facebookPixel: {
        code: '',
        facebookEvents: [''],
      },
      userVoice: 'fstYbP5lDoofPPZa8JFig',
      url: '/v2/bancolombia/soat/seguro-obligatorio',
      codigoCanal: '14619',
      codigoAsesor: '4999',
    },
    {
      tenant: TenantName.BANCO_DE_OCCIDENTE,
      hostname: 'https://www.bancodeoccidente.com.co',
      pixelResponsys: {
        url:
          'https://emailbancodeoccidente.com.co/pub/cct?_ri_=X0Gzc2X%3DAQpglLjHJlDQGtKmyRGIdp4mXLfeSMwzbSih&_ei_=EoPlssws7ktzS6UAe8DyEo0',
        width: '1',
        height: '1',
      },
      googleTagManager: {
        GTM: 'GTM-5R4TXN',
        UA: 'UA-27527568-1',
        globalSite: 'UA-3571024-60',
        optimizeId: '',
      },
      facebookPixel: {
        code: '',
        facebookEvents: [''],
      },
      userVoice: 'fstYbP5lDoofPPZa8JFig',
      url: '/',
      codigoCanal: '301',
      codigoAsesor: '4999',
    },
    {
      tenant: 'suratech',
      hostname: 'http://localhost:4200',
      pixelResponsys: {
        url: '',
        width: '',
        height: '',
      },
      googleTagManager: {
        GTM: 'GTM-5R4TXN',
        globalSite: 'UA-27527568-1',
        UA: 'UA-27527568-1',
        optimizeId: 'GTM-PSFM4S5',
      },
      facebookPixel: {
        code: '380531805706245',
        facebookEvents: ['PageView'],
      },
      userVoice: 'fstYbP5lDoofPPZa8JFig',
      url: '/',
      codigoCanal: '7771',
      codigoAsesor: '4999',
    },
  ],
};
